import apiClient from './axios-instance'
import {
  CreateReportIssueRequest,
  GetReportIssuesRequest,
  ReportIssueApiResponse,
  ReportIssuesListApiResponse,
} from '@/lib/types/report-issue.types'

/**
 * Report Issue API Service
 * Handles technical issue reporting with file upload support
 */
export const reportIssueApi = {
  /**
   * Get all report issues with optional filters and pagination
   */
  getAll: async (params?: GetReportIssuesRequest): Promise<ReportIssuesListApiResponse> => {
    const response = await apiClient.get<ReportIssuesListApiResponse>(
      '/report-issues/report-issues',
      {
        params: {
          status_filter: params?.status_filter,
          search: params?.search,
          sort_by: params?.sort_by,
          sort_order: params?.sort_order || 'desc',
          page: params?.page || 1,
          page_size: params?.page_size,
        },
      }
    )
    return response.data
  },

  /**
   * Get a single report issue by ID
   */
  getById: async (issueId: string): Promise<ReportIssueApiResponse> => {
    const response = await apiClient.get<ReportIssueApiResponse>(
      `/report-issues/report-issues/${issueId}`
    )
    return response.data
  },

  /**
   * Create a new report issue
   * Sends multipart/form-data with optional file attachment
   */
  create: async (data: CreateReportIssueRequest): Promise<ReportIssueApiResponse> => {
    // Create FormData for multipart/form-data request
    const formData = new FormData()

    formData.append('issue_description', data.issue_description)

    // Add attachment if provided
    if (data.attachment) {
      formData.append('attachment', data.attachment)
    }

    const response = await apiClient.post<ReportIssueApiResponse>(
      '/report-issues/report-issues',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return response.data
  },
}

